import { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

import draggablePanelHooks from 'components/primary/DraggablePanel/Hooks';
import { getResizedPanelState } from 'components/primary/DraggablePanel/Helpers';
import DraggablePanelResizer from 'components/primary/DraggablePanel/Resizer';

const MIN_WIDTH = 320
const MIN_HEIGHT = 256
const MAX_WIDTH_OFFSET = 64
const MAX_HEIGHT_OFFSET = 180

const useWindowBounds = () => useMemo(() => ({
  maxHeight: Math.max(MIN_HEIGHT, window.innerHeight - MAX_HEIGHT_OFFSET),
  maxWidth: Math.max(MIN_WIDTH, window.innerWidth - MAX_WIDTH_OFFSET)
}), [])

const { usePanelPositionSync, usePanelResize, usePanelSize } = draggablePanelHooks
const Resizer = ({ panelRef, panelPosition, setPanelPosition }) => {
  const bounds = useWindowBounds(),
        getInitialPanelSize = useCallback(() => ({ height: 400, width: 400 }), []),
        { panelSizeRef, setPanelSize } = usePanelSize({ getInitialPanelSize, panelRef }),
        updatePanelPosition = usePanelPositionSync({ setPanelPosition }),
        getResizedPanelStateLocal = useCallback(({ direction, event, start }) => getResizedPanelState({ direction, event, maxHeight: bounds.maxHeight, maxWidth: bounds.maxWidth, minHeight: MIN_HEIGHT, minWidth: MIN_WIDTH, start }), [bounds]),
        { onResizeStart } = usePanelResize({ getResizedPanelState: getResizedPanelStateLocal, panelPosition, panelRef, panelSizeRef, setPanelSize, updatePanelPosition })

  return (
    <DraggablePanelResizer
        classNamePrefix="ng-python-editor__chat__resizer"
        onResizeStart={onResizeStart}
    />
  )
}

Resizer.propTypes = {
  panelPosition: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number
  }).isRequired,
  panelRef: PropTypes.object.isRequired,
  setPanelPosition: PropTypes.func.isRequired
}

export default Resizer
